export default "/react/mtsIcon-9b2050f4.svg";